import { render, staticRenderFns } from "./files_asset_desc.vue?vue&type=template&id=64a6fa95&scoped=true&lang=pug&"
import script from "./files_asset_desc.vue?vue&type=script&lang=js&"
export * from "./files_asset_desc.vue?vue&type=script&lang=js&"
import style0 from "./files_asset_desc.vue?vue&type=style&index=0&id=64a6fa95&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a6fa95",
  null
  
)

export default component.exports